<template>
  <section class="things-rights">
    <header class="right-header">
      <h2 class="title-rights">{{thingUsers.length}} {{labelUsers}}</h2>
      <div class="header-right">
        <button type="button"
                @click="showControlPopup"
                class="btn btn-transparent_blue">
          {{$t('btns.things.thingsControl')}}
        </button>
        <button type="button"
                v-if="checkedUsers.length > 0"
                @click="checkDel"
                class="control-btn hover-red hint-cont">
          <del-icon></del-icon>
        </button>
      </div>
    </header>

    <table-component :legend="createLegendRights()"
                     :clear-checked="clearMarker"
                     :class-name="'users-item'"
                     :column-width="columnWidthRights"
                     :all-checked="allChecked"
                     :columns="columnsRights"
                     @changeCheckbox="checkedUsers = $event"
                     @filterName="filterName($event, 'legendRights')"
                     @filterMail="filterMail($event, 'legendRights')"
                     @filterRights="filterRights($event, 'legendRights')"></table-component>

    <!--<ul class="users-item">-->
      <!--<li class="user-item right-item" v-for="user in thingUsers">-->
        <!--<div class="cell1">-->
          <!--<label class="check-cont_small check-cont check-cont_opacity">-->
            <!--<input type="checkbox"-->
                   <!--:value="user"-->
                   <!--@change="checkItem"-->
                   <!--v-model="checkedUsers"-->
                   <!--:key="user.id">-->
            <!--<p class="check-label"></p>-->
          <!--</label>-->
        <!--</div>-->
        <!--<div class="cell2">-->
          <!--<div class="avatar-cont"-->
               <!--:style="{backgroundImage: 'url(' + user.role.owner.contacts.avatar_url + ')'}">-->
            <!--<user-icon v-if="!user.role.owner.contacts.avatar_url"></user-icon>-->
          <!--</div>-->

          <!--{{user.role.owner.first_name}} {{user.role.owner.second_name}}-->
        <!--</div>-->
        <!--<div class="cell3">-->
          <!--{{user.role.owner.contacts.email}}-->
        <!--</div>-->
        <!--<div class="cell4">-->
          <!--{{returnPermission(user)}}-->
        <!--</div>-->
      <!--</li>-->
    <!--</ul>-->
  </section>
</template>

<script>
  import {thingRightsControl} from "../../../../mixins/things/thingRightsControls";

  export default {
    name: 'thingsRights',
    mixins: [thingRightsControl],
    computed: {
      thingUsers() {
       let arr = this.thing.permissions.filter(item => {
          return item.role.owner
        });

        if (this.nameFiltered) {
          arr = arr.sort((a,b) => {
            let nameA = a.role.owner.first_name;
            if (nameA == null) {
              nameA = ' '
            };
            let nameB = b.role.owner.first_name;
            if (nameB == null) {
              nameB = ' '
            }

            if (this.nameUp) {
              if (nameA < nameB) return 1;
              if (nameA > nameB) return -1;
              return 0
            };

            if (this.nameDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            }
          });
          return arr
        };

        if (this.mailFiltered) {
          arr = arr.sort((a,b) => {
            let nameA = a.role.owner.contacts.email;
            let nameB = b.role.owner.contacts.email;

            if (this.mailUp) {
              if (nameA < nameB) return 1;
              if (nameA > nameB) return -1;
              return 0
            };

            if (this.mailDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            }
          });
          return arr
        };

        if (this.rightsFiltered) {
          arr = arr.sort((a,b) => {
            let nameA = a.value;
            let nameB = b.value;

            if (this.rightsUp) {
              if (nameA < nameB) return 1;
              if (nameA > nameB) return -1;
              return 0
            };

            if (this.rightDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            }
          });
          return arr
        };

        return arr;
      },
      labelUsers() {
        let users = this.thingUsers.length;
        users = String(users).slice(-1);

        if (users == 0 || users > 5) {
          return this.$t('things.user0')
        };

        if (users == 1) {
          return this.$t('things.user1')
        };

        if (users > 1 && users < 5) {
          return this.$t('things.user2')
        };
      }
    },
    methods: {
      showControlPopup() {
        this.showOverlay(true);
        this.setDefaultRight(this.checkedUsers);
        this.setRightsType('user');
        this.setRightsDeviceType('device');
        this.showRightsControl(true);

      },
      checkDel() {
        let string = '';
        this.checkedUsers.forEach((item) => {
          string += `${item.role.owner.first_name} ${item.role.owner.second_name}, `
        });
        string = string.slice(0,-2);

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
      },
      async deleteItems() {
        this.showLoader();
        let emails = this.checkedUsers.map(item => {
          return item.role.owner.contacts.email
        }).join(',');
        let data = {
          //access_token: this.token,
          object_id: this.thing.id,
          object_name: 'device',
          value: -1,
          emails
        };

        await this.setPermissions({data, token: this.token});
        this.clearMarker = true;
        this.checkedUsers = [];
        this.clearMarker = false;
        this.hideLoader();
      },


    }
  }
</script>

<style lang="scss" scoped>
  .right-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 10px;
    min-height: 40px;
  }

  .title-rights {
    font-family: $msb;
    font-size: 14px;
    letter-spacing: .25px;
  }

  .header-right {
   display: flex;
    align-items: center;

    .btn {
      height: 40px;
      padding: 0 15px;
      font-size: $mm;
    }

    .control-btn {
      min-width: 40px;
      margin-left: 20px;
    }
  }
</style>
